import { Injectable, Injector } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/internal/operators/catchError';
import { Router } from '@angular/router';
import { AuthService } from '@app/core/auth/auth.service';
import { ItauUserIdleService } from '@app/core/security/itau-user-idle.service';
import { EnvironmentService } from './core/environment/environment.service';
import { DatadogService } from './shared/services/datadog/datadog.service';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
    private iServicesUri: string;

    constructor(
      private injector: Injector,
      private environmentService: EnvironmentService,
      private _datadogService:DatadogService
      ) {}

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        const router = this.injector.get(Router);

        if (sessionStorage.getItem('sessionState') == 'true') {
            request = request.clone({
                withCredentials: true
            });
        }

        return <any>next.handle(request)
            .pipe(
                catchError((error: HttpErrorResponse) => {
                  this._datadogService.sendErrorLogs(error.message);
                  this.iServicesUri = this.environmentService.envModel.appSettings.fm6ApiUrlFeatureToggle;

                    if (error.status == 403) {
                        const authService = this.injector.get(AuthService);
                        const userIdleService = this.injector.get(ItauUserIdleService);

                        if (error.url.indexOf(this.iServicesUri) === -1) {
                          userIdleService.stopWatching();
                          authService.logout(true);
                          return throwError('Sessão Inválida');
                        }

                    } else {
                      return throwError(error);
                    }
                })
            );
    }
}
